// HOME PAGE
import heroImage from "./heroPhoto.png";
import home_Img1 from "../images/homePage/icon-Img1.png";
import home_Img2 from "../images/homePage/icon-Img2.png";
import home_Img3 from "../images/homePage/icon-Img3.png";
// OUR COMPANY PAGE
import bg_Img1 from "../images/ourCompanyPage/bg-ourCompany1.png";
import bg_Img2 from "../images/ourCompanyPage/bg-ourCompany2.png";
import bg_Img3 from "../images/ourCompanyPage/bg-ourCompany3.png";
import our_img1 from "../images/ourCompanyPage/our-img1.svg";
import our_img2 from "../images/ourCompanyPage/our-img2.svg";
import our_img3 from "../images/ourCompanyPage/our-img3.svg";
// CATALOG PAGE
import web_Img1 from "../images/catalogImages/web-Img1.png";
import web_Img2 from "../images/catalogImages/web-Img2.png";
import web_Img3 from "../images/catalogImages/web-Img3.png";
import web_Img4 from "../images/catalogImages/web-Img4.png";
import web_Img5 from "../images/catalogImages/web-Img5.png";
import web_Img6 from "../images/catalogImages/web-Img6.png";
import app_Img1 from "../images/catalogImages/app-Img1.png";
import app_Img2 from "../images/catalogImages/app-Img2.png";
import app_Img3 from "../images/catalogImages/app-Img3.png";
import app_Img4 from "../images/catalogImages/app-Img4.png";
import app_Img5 from "../images/catalogImages/app-Img5.png";
import graphic_Img1 from "../images/catalogImages/graphic-Img1.png";
import graphic_Img2 from "../images/catalogImages/graphic-Img2.png";
import graphic_Img3 from "../images/catalogImages/graphic-Img3.png";
// LOCATION PAGE
import loc_img1 from "../images/locationPage/loc-img1.png";
import loc_img2 from "../images/locationPage/loc-img2.png";
import loc_img3 from "../images/locationPage/loc-img3.png";

// EXPORT
export const allImages = {
    homeImages: {
        heroImage,
        home_Img1,
        home_Img2,
        home_Img3,
    },
    ourCompanyImages: {
        bg_Img1,
        bg_Img2,
        bg_Img3,
        our_img1,
        our_img2,
        our_img3,
    },
    catalogImages: {
        web_Img1,
        web_Img2,
        web_Img3,
        web_Img4,
        web_Img5,
        web_Img6,
        app_Img1,
        app_Img2,
        app_Img3,
        app_Img4,
        app_Img5,
        graphic_Img1,
        graphic_Img2,
        graphic_Img3,
    },
    locationImages: {
        loc_img1,
        loc_img2,
        loc_img3,
    },
};
